(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-swatches"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('card-swatches')) {
    class CardSwatches extends HTMLElement {
      connectedCallback() {
        this.card = this.closest('.card-wrapper');
        this.buttons = Array.from(this.querySelectorAll('.card-swatches__swatch'));
        this.preloaded = false;

        this.buttons.forEach((button) => {
          button.addEventListener('mouseenter', () => this.select(button));
          button.addEventListener('focus', () => this.select(button));
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.select(button);
          });
        });

        const preload = () => this.preload();
        this.card?.addEventListener('mouseenter', preload, { once: true });
        this.addEventListener('touchstart', preload, { once: true, passive: true });
      }

      preload() {
        if (this.preloaded) return;
        this.preloaded = true;
        const image = this.card?.querySelector('.card__media img');
        this.buttons.forEach((button) => {
          if (!button.dataset.src) return;
          const preloadImage = new Image();
          if (image?.sizes) preloadImage.sizes = image.sizes;
          if (button.dataset.srcset) preloadImage.srcset = button.dataset.srcset;
          preloadImage.src = button.dataset.src;
        });
      }

      select(button) {
        if (!this.card) return;

        this.buttons.forEach((item) => {
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });

        const image = this.card.querySelector('.card__media img');
        if (image && button.dataset.src) {
          if (button.dataset.srcset) {
            image.srcset = button.dataset.srcset;
          } else {
            image.removeAttribute('srcset');
          }
          image.src = button.dataset.src;
          if (button.dataset.alt) image.alt = button.dataset.alt;
          if (button.dataset.width) image.width = button.dataset.width;
          if (button.dataset.height) image.height = button.dataset.height;
          this.card.classList.add('card-wrapper--swatch-selected');
        }

        if (button.dataset.url) {
          this.card.querySelectorAll('.card__heading a[href]').forEach((link) => {
            link.href = button.dataset.url;
          });
        }
      }
    }

    customElements.define('card-swatches', CardSwatches);
  }
  } catch(e) { console.error(e); }
})();

})();
